// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Operations-page {
  width: 100%;
  padding: 0;
}

.status-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  background-color: white;
  width: fit-content;
  padding: 1rem;
  border-radius: 50px;
}

.Operations-section {
  margin-top: 3rem;
}

/* .Operations-page h2 {
  font-size:3.2rem;
} */

/* .tableau-de-bord-section {
    border: 2px solid #2C3948;
    border-radius: 10px;
    padding: 2rem;
} */

.tableau-de-bord-section h1 {
  margin-bottom: 0;
}

/* Header avec titre à gauche et boutons/message à droite */
.commandes-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;
  margin-bottom: 4rem;
}

.commandes-header h1 {
  margin-bottom: 0;
}

.commandes-header .commandes-actions {
  flex-shrink: 0;
  /* margin-top: 4rem; */
}

/* Espacement égal au-dessus et en-dessous de la barre de recherche/boutons.
   Les boutons d'action (Nouveau BC / Nouveau MS) sont alignés à droite de cette ligne,
   la recherche + exporter + filtrer restant à gauche (button-group = flex space-between). */
.commandes-page .button-group {
  margin-top: 0;
  margin-bottom: 3rem;
  align-items: center;
  gap: 2rem;
}
.commandes-page .button-group .commandes-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-shrink: 0;
}

/* Réduire l'espacement sous les tabs pour équilibrer */
.commandes-page .tab-nav {
  margin-bottom: 3rem;
}

.page-header.client-view .buttons-container {
  /* display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
  width: 100%; */
}

.page-header .buttons-container {
  /* margin: 0 0 2.5rem 0; */
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.page-header.client-view {
  /* flex-direction: column; */
  /* align-items: flex-start; */
  gap: 2rem;
  width: 100%;
}

.montant-operation {
  font-weight: 700;
  text-align: right !important;
  white-space: nowrap;
}
/* new styles */

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.4rem 1.2rem;
  border-radius: 12px;
  font-size: 1.4rem;
  font-weight: 700;
}

/* Statut du tableau ACHETEUR : une ligne tant qu'il y a la place, deux lignes quand le libelle est
   trop long pour la colonne ("En attente de l'acceptation du rang 1", 37 caracteres).

   Pas de max-width : ce serait un plafond arbitraire qui couperait le libelle en deux meme sur un
   grand ecran. Le badge est un enfant direct du td, donc \`.tableau-container td > div\` lui donne
   deja width:100% ; le tableau (layout auto, width 100%) elargit la colonne tant qu'il peut, puis la
   comprime — le texte se replie tout seul au bon moment. \`white-space: normal\` est explicite pour
   rester immunise si une des autres declarations globales passait a nowrap.

   Ancre sur .tableau-operations (exclusif a cette page) et NON sur .status-badge seul : cette classe
   est declaree A L'IDENTIQUE dans 6 CSS globaux, dont la liste prestataire (Commandes.css) — une
   regle non ancree wrapperait aussi le tableau presta. La specificite (0,2,0) la fait gagner sans
   !important, quel que soit l'ordre de chargement des feuilles. */
.tableau-operations .status-badge {
  /* Statut sur UNE ligne. La troncature a 3 mots est faite en amont (tronquerLibelleStatut) : le
     tableau etant en \`table-layout: auto\`, une colonne en \`nowrap\` s'elargit jusqu'a tout afficher,
     donc \`text-overflow\` seul ne se declencherait jamais. Il reste ici en filet pour les ecrans
     etroits, ou la colonne est comprimee.
     \`block\` et non \`inline-flex\` (valeur de base) : \`text-overflow\` ne s'applique PAS au contenu
     d'un conteneur flex. Sans fond sur la pastille (padding + couleur seulement), passer en block
     ne cree aucune barre pleine largeur. */
  display: block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}

.status-badge.accepté,
.valide,
.status-badge.accepte {
  color: #00a708;
}

.status-badge.brouillons {
  color: #6b7280;
}

.status-badge.action-requise {
  color: #f4751b;
}

.status-badge.a-relancer {
  color: #f97316;
}

.status-badge.refusé {
  color: #d90e0e;
}

.status-badge.expiré,
.status-badge.expire {
  color: #d90e0e;
}

.status-badge.annulé,
.status-badge.annule {
  color: #d90e0e;
}

.status-badge.en-attente,
.consultation-en-cours,
.en-attente-de-l-offre,
.en-attente-de-l-acceptation-du-rang-1,
.en-attente-de-l-acceptation-du-rang-2,
.en-attente-de-l-acceptation-du-rang-3 {
  color: #6b7280;
}

.status-badge.inconnu {
  color: #e5e7eb;
}

.tableau-container {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.tableau th {
  padding: 1rem;
  background-color: #f9f9f9;
  position: relative;
  cursor: pointer;
}

.sort-icon {
  position: absolute;
  right: -1px;
  top: 50%;
  transform: translateY(-50%);
}

.action-button {
  border-radius: 8px;
  padding: 8px 20px;
  font-weight: 600;
}

.action-button.action-requise {
  background-color: #f97316;
  color: #fffdfc;
  border: none;
}

.action-button.action-requise:hover {
  background-color: #ea580c;
  color: #fffdfc;
  border: none;
}

.countdown {
  color: #f97316;
  font-weight: 600;
}

td .action-button {
  font-size: 1.2rem !important;
  width: 140px;
}

/* Etat validé : libellé long ("Marché subséquent" / "Bon de commande") tenu sur UNE
   seule ligne. Ces lignes n'ont pas de bouton poubelle (réservé aux brouillons),
   donc le bouton peut s'élargir dans la place déjà prise par la colonne. width:auto +
   nowrap = épouse le contenu sans jamais wrapper ; min-width garde la cohérence visuelle. */
td .action-button.action-button--pdf {
  width: auto;
  min-width: 140px;
  white-space: nowrap;
  padding-left: 12px;
  padding-right: 12px;
}

td .countdown {
  border-width: 1px !important;
  font-size: 1.1rem;
  white-space: nowrap;
}

td .Operation-nom {
  min-width: 150px;
}

/* Style pour tronquer le texte qui dépasse */
.lot-technique.text-truncate {
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

/* Ajoutez un titre (tooltip) qui apparaît au survol pour voir le texte complet */
.lot-technique.text-truncate:hover {
  position: relative;
}

/* Ajouter à Operations.css */
.text-truncate {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  max-height: 2.8em; /* ~2 lines */
  line-height: 1.4em;
}

.client-info,
.lot-technique,
.lot-geographique,
.user-info,
.Operation-nom,
.date-info,
.type-info {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  line-height: 1.4em;
}

.tableau-container td {
  vertical-align: top;
  padding: 4px 6px;
}

/* Pour assurer que les points de suspension s'affichent correctement */
.tableau-container td > div {
  position: relative;
  width: 100%;
}

td .button {
  padding: 0.5rem !important;
}

/* Décommenter pour activer les séparateurs de lignes dans les tableaux */
tr {
  padding: 4px 0px;
  border-bottom: 1px solid #e2e8f0;
}

/* Loading Indicator */
.loading-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  min-height: 300px;
  background-color: #f9fafb;
  border-radius: 8px;
  margin-top: 1rem;
}

.loading-indicator .spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #e5e7eb;
  border-top-color: #f97316;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1.5rem;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loading-indicator p {
  color: #6b7280;
  font-size: 1.6rem;
  font-weight: 500;
  margin: 0;
}

/* Error Message */
.error-message {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  min-height: 20px;
  background-color: #fef2f2;
  border-radius: 8px;
  margin-top: 1rem;
}

.error-message p {
  color: #dc2626;
  font-size: 1.4rem;
  font-weight: 500;
  margin: 0;
}

/* Filter Reset Button */
.filter-button-container {
  display: flex;
  align-items: center;
  position: relative;
}

.filter-reset-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border: none;
  background-color: #dc2626;
  color: white;
  border-radius: 50%;
  font-size: 1.4rem;
  font-weight: bold;
  cursor: pointer;
  margin-left: 0.5rem;
  transition:
    background-color 0.2s ease,
    transform 0.2s ease;
}

.filter-reset-button:hover {
  background-color: #b91c1c;
  transform: scale(1.1);
}

.filter-reset-button:active {
  transform: scale(0.95);
}

.msg-unread-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 5px;
  margin-left: 0;
  background-color: #dc2626;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  border-radius: 50%;
  line-height: 1;
  vertical-align: middle;
}

/* Colonne Notification : centrée, largeur fixe */
.tableau-operations .tableau-container td:first-child,
.tableau-operations .tableau-container th:first-child {
  text-align: center;
  vertical-align: middle;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Operation/Operation.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;GAEG;;AAEH;;;;GAIG;;AAEH;EACE,gBAAgB;AAClB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;;4FAE4F;AAC5F;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE,mBAAmB;AACrB;;AAEA;EACE;;;;gBAIc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;AACA,eAAe;;AAEf;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;kEAYkE;AAClE;EACE;;;;;;2CAMyC;EACzC,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;AACd;;AAEA;;;4FAG4F;AAC5F;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,iFAAiF;AACjF;EACE,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,uBAAuB;EACvB,iBAAiB,EAAE,aAAa;EAChC,kBAAkB;AACpB;;AAEA;;;;;;;EAOE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,uEAAuE;AACvE;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,yEAAyE;AACzE;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB;;uBAEqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA,iDAAiD;AACjD;;EAEE,kBAAkB;EAClB,sBAAsB;AACxB","sourcesContent":[".Operations-page {\r\n  width: 100%;\r\n  padding: 0;\r\n}\r\n\r\n.status-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  background-color: white;\r\n  width: fit-content;\r\n  padding: 1rem;\r\n  border-radius: 50px;\r\n}\r\n\r\n.Operations-section {\r\n  margin-top: 3rem;\r\n}\r\n\r\n/* .Operations-page h2 {\r\n  font-size:3.2rem;\r\n} */\r\n\r\n/* .tableau-de-bord-section {\r\n    border: 2px solid #2C3948;\r\n    border-radius: 10px;\r\n    padding: 2rem;\r\n} */\r\n\r\n.tableau-de-bord-section h1 {\r\n  margin-bottom: 0;\r\n}\r\n\r\n/* Header avec titre à gauche et boutons/message à droite */\r\n.commandes-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: 2rem;\r\n  margin-bottom: 4rem;\r\n}\r\n\r\n.commandes-header h1 {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.commandes-header .commandes-actions {\r\n  flex-shrink: 0;\r\n  /* margin-top: 4rem; */\r\n}\r\n\r\n/* Espacement égal au-dessus et en-dessous de la barre de recherche/boutons.\r\n   Les boutons d'action (Nouveau BC / Nouveau MS) sont alignés à droite de cette ligne,\r\n   la recherche + exporter + filtrer restant à gauche (button-group = flex space-between). */\r\n.commandes-page .button-group {\r\n  margin-top: 0;\r\n  margin-bottom: 3rem;\r\n  align-items: center;\r\n  gap: 2rem;\r\n}\r\n.commandes-page .button-group .commandes-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Réduire l'espacement sous les tabs pour équilibrer */\r\n.commandes-page .tab-nav {\r\n  margin-bottom: 3rem;\r\n}\r\n\r\n.page-header.client-view .buttons-container {\r\n  /* display: flex;\r\n  gap: 1rem;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: 100%; */\r\n}\r\n\r\n.page-header .buttons-container {\r\n  /* margin: 0 0 2.5rem 0; */\r\n}\r\n\r\n.page-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.page-header.client-view {\r\n  /* flex-direction: column; */\r\n  /* align-items: flex-start; */\r\n  gap: 2rem;\r\n  width: 100%;\r\n}\r\n\r\n.montant-operation {\r\n  font-weight: 700;\r\n  text-align: right !important;\r\n  white-space: nowrap;\r\n}\r\n/* new styles */\r\n\r\n.status-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 0.4rem 1.2rem;\r\n  border-radius: 12px;\r\n  font-size: 1.4rem;\r\n  font-weight: 700;\r\n}\r\n\r\n/* Statut du tableau ACHETEUR : une ligne tant qu'il y a la place, deux lignes quand le libelle est\r\n   trop long pour la colonne (\"En attente de l'acceptation du rang 1\", 37 caracteres).\r\n\r\n   Pas de max-width : ce serait un plafond arbitraire qui couperait le libelle en deux meme sur un\r\n   grand ecran. Le badge est un enfant direct du td, donc `.tableau-container td > div` lui donne\r\n   deja width:100% ; le tableau (layout auto, width 100%) elargit la colonne tant qu'il peut, puis la\r\n   comprime — le texte se replie tout seul au bon moment. `white-space: normal` est explicite pour\r\n   rester immunise si une des autres declarations globales passait a nowrap.\r\n\r\n   Ancre sur .tableau-operations (exclusif a cette page) et NON sur .status-badge seul : cette classe\r\n   est declaree A L'IDENTIQUE dans 6 CSS globaux, dont la liste prestataire (Commandes.css) — une\r\n   regle non ancree wrapperait aussi le tableau presta. La specificite (0,2,0) la fait gagner sans\r\n   !important, quel que soit l'ordre de chargement des feuilles. */\r\n.tableau-operations .status-badge {\r\n  /* Statut sur UNE ligne. La troncature a 3 mots est faite en amont (tronquerLibelleStatut) : le\r\n     tableau etant en `table-layout: auto`, une colonne en `nowrap` s'elargit jusqu'a tout afficher,\r\n     donc `text-overflow` seul ne se declencherait jamais. Il reste ici en filet pour les ecrans\r\n     etroits, ou la colonne est comprimee.\r\n     `block` et non `inline-flex` (valeur de base) : `text-overflow` ne s'applique PAS au contenu\r\n     d'un conteneur flex. Sans fond sur la pastille (padding + couleur seulement), passer en block\r\n     ne cree aucune barre pleine largeur. */\r\n  display: block;\r\n  max-width: 100%;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  text-align: left;\r\n}\r\n\r\n.status-badge.accepté,\r\n.valide,\r\n.status-badge.accepte {\r\n  color: #00a708;\r\n}\r\n\r\n.status-badge.brouillons {\r\n  color: #6b7280;\r\n}\r\n\r\n.status-badge.action-requise {\r\n  color: #f4751b;\r\n}\r\n\r\n.status-badge.a-relancer {\r\n  color: #f97316;\r\n}\r\n\r\n.status-badge.refusé {\r\n  color: #d90e0e;\r\n}\r\n\r\n.status-badge.expiré,\r\n.status-badge.expire {\r\n  color: #d90e0e;\r\n}\r\n\r\n.status-badge.annulé,\r\n.status-badge.annule {\r\n  color: #d90e0e;\r\n}\r\n\r\n.status-badge.en-attente,\r\n.consultation-en-cours,\r\n.en-attente-de-l-offre,\r\n.en-attente-de-l-acceptation-du-rang-1,\r\n.en-attente-de-l-acceptation-du-rang-2,\r\n.en-attente-de-l-acceptation-du-rang-3 {\r\n  color: #6b7280;\r\n}\r\n\r\n.status-badge.inconnu {\r\n  color: #e5e7eb;\r\n}\r\n\r\n.tableau-container {\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.tableau th {\r\n  padding: 1rem;\r\n  background-color: #f9f9f9;\r\n  position: relative;\r\n  cursor: pointer;\r\n}\r\n\r\n.sort-icon {\r\n  position: absolute;\r\n  right: -1px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n}\r\n\r\n.action-button {\r\n  border-radius: 8px;\r\n  padding: 8px 20px;\r\n  font-weight: 600;\r\n}\r\n\r\n.action-button.action-requise {\r\n  background-color: #f97316;\r\n  color: #fffdfc;\r\n  border: none;\r\n}\r\n\r\n.action-button.action-requise:hover {\r\n  background-color: #ea580c;\r\n  color: #fffdfc;\r\n  border: none;\r\n}\r\n\r\n.countdown {\r\n  color: #f97316;\r\n  font-weight: 600;\r\n}\r\n\r\ntd .action-button {\r\n  font-size: 1.2rem !important;\r\n  width: 140px;\r\n}\r\n\r\n/* Etat validé : libellé long (\"Marché subséquent\" / \"Bon de commande\") tenu sur UNE\r\n   seule ligne. Ces lignes n'ont pas de bouton poubelle (réservé aux brouillons),\r\n   donc le bouton peut s'élargir dans la place déjà prise par la colonne. width:auto +\r\n   nowrap = épouse le contenu sans jamais wrapper ; min-width garde la cohérence visuelle. */\r\ntd .action-button.action-button--pdf {\r\n  width: auto;\r\n  min-width: 140px;\r\n  white-space: nowrap;\r\n  padding-left: 12px;\r\n  padding-right: 12px;\r\n}\r\n\r\ntd .countdown {\r\n  border-width: 1px !important;\r\n  font-size: 1.1rem;\r\n  white-space: nowrap;\r\n}\r\n\r\ntd .Operation-nom {\r\n  min-width: 150px;\r\n}\r\n\r\n/* Style pour tronquer le texte qui dépasse */\r\n.lot-technique.text-truncate {\r\n  max-width: 100px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  display: block;\r\n}\r\n\r\n/* Ajoutez un titre (tooltip) qui apparaît au survol pour voir le texte complet */\r\n.lot-technique.text-truncate:hover {\r\n  position: relative;\r\n}\r\n\r\n/* Ajouter à Operations.css */\r\n.text-truncate {\r\n  overflow: hidden;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  text-overflow: ellipsis;\r\n  max-height: 2.8em; /* ~2 lines */\r\n  line-height: 1.4em;\r\n}\r\n\r\n.client-info,\r\n.lot-technique,\r\n.lot-geographique,\r\n.user-info,\r\n.Operation-nom,\r\n.date-info,\r\n.type-info {\r\n  overflow: hidden;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  text-overflow: ellipsis;\r\n  line-height: 1.4em;\r\n}\r\n\r\n.tableau-container td {\r\n  vertical-align: top;\r\n  padding: 4px 6px;\r\n}\r\n\r\n/* Pour assurer que les points de suspension s'affichent correctement */\r\n.tableau-container td > div {\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\ntd .button {\r\n  padding: 0.5rem !important;\r\n}\r\n\r\n/* Décommenter pour activer les séparateurs de lignes dans les tableaux */\r\ntr {\r\n  padding: 4px 0px;\r\n  border-bottom: 1px solid #e2e8f0;\r\n}\r\n\r\n/* Loading Indicator */\r\n.loading-indicator {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 4rem 2rem;\r\n  min-height: 300px;\r\n  background-color: #f9fafb;\r\n  border-radius: 8px;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.loading-indicator .spinner {\r\n  width: 48px;\r\n  height: 48px;\r\n  border: 4px solid #e5e7eb;\r\n  border-top-color: #f97316;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n@keyframes spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.loading-indicator p {\r\n  color: #6b7280;\r\n  font-size: 1.6rem;\r\n  font-weight: 500;\r\n  margin: 0;\r\n}\r\n\r\n/* Error Message */\r\n.error-message {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 2rem;\r\n  min-height: 20px;\r\n  background-color: #fef2f2;\r\n  border-radius: 8px;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.error-message p {\r\n  color: #dc2626;\r\n  font-size: 1.4rem;\r\n  font-weight: 500;\r\n  margin: 0;\r\n}\r\n\r\n/* Filter Reset Button */\r\n.filter-button-container {\r\n  display: flex;\r\n  align-items: center;\r\n  position: relative;\r\n}\r\n\r\n.filter-reset-button {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 2rem;\r\n  height: 2rem;\r\n  border: none;\r\n  background-color: #dc2626;\r\n  color: white;\r\n  border-radius: 50%;\r\n  font-size: 1.4rem;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n  margin-left: 0.5rem;\r\n  transition:\r\n    background-color 0.2s ease,\r\n    transform 0.2s ease;\r\n}\r\n\r\n.filter-reset-button:hover {\r\n  background-color: #b91c1c;\r\n  transform: scale(1.1);\r\n}\r\n\r\n.filter-reset-button:active {\r\n  transform: scale(0.95);\r\n}\r\n\r\n.msg-unread-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 20px;\r\n  height: 20px;\r\n  padding: 0 5px;\r\n  margin-left: 0;\r\n  background-color: #dc2626;\r\n  color: #fff;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  border-radius: 50%;\r\n  line-height: 1;\r\n  vertical-align: middle;\r\n}\r\n\r\n/* Colonne Notification : centrée, largeur fixe */\r\n.tableau-operations .tableau-container td:first-child,\r\n.tableau-operations .tableau-container th:first-child {\r\n  text-align: center;\r\n  vertical-align: middle;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
